// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"634":"f7e7613a","788":"be8018f2"}[chunkId] + ".chunk.js";
};